// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1WtIY","clinicsSelect":"TableHeading_clinicsSelect__TOjTM"};